import React from 'react';
import styled from 'styled-components/macro';
import { themeGetCss } from '@blueprint/ui';

import Box from '../Box';

export const OptionBox = styled(Box)(themeGetCss('nativeDropdown.option'));

const Option = ({ children, ...rest }) => {
  return (
    <OptionBox as="option" {...rest}>
      {children}
    </OptionBox>
  );
};

Option.displayName = 'Option';

export default Option;
